import { LogInPage } from "@/pages/log-in";
import { LandingPage } from "@/pages/landing";
import { RouteObject } from "react-router-dom";
import { LogOutPage } from "@/pages/log-out";
import { GoogleOAuthRedirectPage } from "@/pages/google-oauth-redirect";
import { GoogleOAuthRedirectDesktopPage } from "@/pages/google-oauth-redirect-desktop";
import { RootOutlet } from "@/app/outlets/RootOutlet";
import { StoreProviderOutlet } from "@/app/outlets/StoreProviderOutlet";
import { GuestNotesViewPage, StandardNotesViewPage } from "@/pages/notes-view/notes-view-page";
import { StandardModeAppLayoutOutlet } from "@/app/outlets/layout/StandardModeAppLayoutOutlet";
import { appRoutes } from "@/app/router/appRoutes";
import { PageElementRouter } from "@/app/outlets/PageElementRouter";
import { RequireGuestModeOrStandardModeOutlet } from "@/app/outlets/RequireGuestModeOrStandardModeOutlet";
import { GuestModeAppLayoutOutlet } from "@/app/outlets/layout/GuestModeAppLayoutOutlet";
import { LogInEmailPasswordPage } from "@/pages/log-in-email-password";
import { LogInOAuthTokenPage } from "@/pages/log-in-oauth-token";
import { STANDARD_MODE_ROUTES } from "@/app/router/standard-mode-routes";
import { RequireStandardModeOverlayOutlet } from "@/app/outlets/RequireStandardModeOverlayOutlet";
import { InvitesPage } from "@/pages/invites";
import { RouterErrorBoundary } from "@/components/error-handling";

const GUEST_MODE_OR_STANDARD_MODE_ROUTES: RouteObject[] = [
  /**
   * =============================================
   *         Notes Routes
   * =============================================
   */
  {
    path: appRoutes.notesView({
      params: { noteId: ":noteId" },
    }).path,
    element: (
      <PageElementRouter
        standardModeElement={<StandardNotesViewPage />}
        guestModeElement={<GuestNotesViewPage />}
      />
    ),
  },
];

export const ALL_APP_ROUTES: RouteObject[] = [
  {
    path: appRoutes.root({}).path,
    element: <RootOutlet />,
    errorElement: <RouterErrorBoundary />,
    children: [
      /**
       * =============================================
       *                Public Routes
       * =============================================
       */
      {
        path: appRoutes.root({}).path,
        element: <LandingPage />,
      },
      {
        path: appRoutes.logInEmailPassword({}).path,
        element: <LogInEmailPasswordPage />,
      },
      {
        path: appRoutes.logInOAuthToken({}).path,
        element: <LogInOAuthTokenPage />,
      },
      {
        path: appRoutes.logIn({}).path,
        element: <LogInPage />,
      },
      {
        path: appRoutes.logOut({}).path,
        element: <LogOutPage />,
      },
      {
        path: appRoutes.googleOAuthRedirect({}).path,
        element: <GoogleOAuthRedirectPage />,
      },
      {
        path: appRoutes.googleOAuthRedirectDesktop({}).path,
        element: <GoogleOAuthRedirectDesktopPage />,
      },

      {
        path: appRoutes.root({}).path,
        element: <StoreProviderOutlet />,
        children: [
          {
            path: appRoutes.invites({ params: { inviteId: ":inviteId" } }).path,
            element: <RequireStandardModeOverlayOutlet />,
            children: [
              {
                index: true,
                element: <InvitesPage />,
              },
            ],
          },
          {
            path: appRoutes.root({}).path,
            element: <RequireGuestModeOrStandardModeOutlet />,
            children: [
              {
                path: appRoutes.root({}).path,
                element: (
                  <PageElementRouter
                    standardModeElement={<StandardModeAppLayoutOutlet />}
                    guestModeElement={<GuestModeAppLayoutOutlet />}
                  />
                ),
                children: [...GUEST_MODE_OR_STANDARD_MODE_ROUTES, ...STANDARD_MODE_ROUTES],
              },
            ],
          },
        ],
      },
    ],
  },
];
